module.exports = __webpack_public_path__ + "img/winter_sports_travel_insurance.f3b94b3e.webp";